exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hello[data-v-54259a90] {\n  background-position: 0 50px;\n  background-repeat: no-repeat;\n  width: 733px;\n  margin: auto;\n}\n.info-box[data-v-54259a90] {\n  -webkit-transition: opacity 0.8s ease;\n  transition: opacity 0.8s ease;\n  background: url(/static/images/info_msg.svg) top center no-repeat;\n  width: 667px;\n  height: 103px;\n  text-align: left;\n  position: absolute;\n  top: 25vh;\n  opacity: 1;\n}\n.info-text[data-v-54259a90] {\n  text-align: center;\n  color: var(--info-primary-color);\n  font-family: 'Open Sans', Arial;\n  font-weight: 400;\n  font-size: 14px;\n  height: 30px;\n  display: inline-block;\n  position: relative;\n  width: 498px;\n  height: 45px;\n  top: calc(50% - (45px / 2));\n  left: calc(50% - (498px / 2));\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54259a90","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Disconnect.vue
// module id = 162
// module chunks = 1